import React from 'react';
import { BaasicDropdown, BaasicInput, Loader } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import ReactTooltip from 'react-tooltip';

const AmazonTemplatesTemplate = ({ t, viewStore: { loading, form, channel, modalParams, addAmazonTemplate } }) => {
	if (loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('AMAZONTEMPLATES.TITLE')}</h3>
				</div>
				<div className="ReactModal__body">
					<div className="row">
						<div className="col col-sml-12 col-med-6 spc--bottom--xsml">
							<div className="card card--xsml card--wh-codes">
								<label className="display--b type--xsml type--wgt--bold type--uppercase type--color--grey-3">
									{t('AMAZONTEMPLATES.SELLER')}
								</label>
								<p className="type--lrg type--wgt--bold">
									{channel || modalParams.data.isEdit ? channel.seller.applicationTitle : '-'}
								</p>
							</div>
						</div>
						<div className="col col-sml-12 col-med-6 spc--bottom--xsml">
							<div className="card card--xsml card--wh-codes">
								<label className="display--b type--xsml type--wgt--bold type--uppercase type--color--grey-3">
									{t('AMAZONTEMPLATES.CHANNEL')}
								</label>
								<p className="type--lrg type--wgt--bold">{channel || modalParams.data.isEdit ? channel.name : '-'}</p>
							</div>
						</div>
					</div>
					<div className="message message--tny message--primary spc--bottom--med">{t('AMAZONTEMPLATES.HINT')}</div>
					<ReactTooltip />
					{/* <BaasicInput field={form.$('defaultPrimeTemplate')} labelTooltip={'AMAZONTEMPLATES.DEFAULTPRIMEHINT'} /> */}
					<table className="table--secondary table--secondary--warehouse table--secondary--codes spc--bottom--sml">
						<thead>
							{/* th value needs to be hardcoded. */}
							<tr>
								<th className="border">
									{t('AMAZONTEMPLATES.SYSTEMCODE')}
									<i
										data-tip={t('AMAZONTEMPLATES.SYSTEMCODEHINT')}
										className="fa fa-info-circle spc--left--tny flex--grow--1"
									></i>
								</th>
								<th className="border">
									{t('AMAZONTEMPLATES.AMAZONCODE')}
									<i
										data-tip={t('AMAZONTEMPLATES.AMAZONCODEHINT')}
										className="fa fa-info-circle spc--left--tny flex--grow--1"
									></i>
								</th>
							</tr>
						</thead>
						<tbody>
							{form.$('amazonTemplates').map(item => {
								return (
									<tr key={item.id}>
										<td>
											<BaasicInput noSpc field={item.$('systemCode')} />
										</td>
										<td>
											<BaasicDropdown dropdownStore={item.templateDropdownStore} />
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
					<div className='type--right'>
						<button
							type="button"
							className="btn btn--med btn--primary spc--bottom--sml"
							onClick={() => addAmazonTemplate()}
						>
							{t('AMAZONTEMPLATES.ADDTEMPLATE')}
						</button>
					</div>
				</div>

				<div className="ReactModal__footer">
					<button className="btn btn--med btn--primary spc--right--tny spc--bottom--sml" type="submit">
						{t('AMAZONTEMPLATES.SAVECODES')}
					</button>
					<button className="btn btn--med btn--outline spc--bottom--sml" onClick={() => modalParams.close()}>
						{t('CANCEL')}
					</button>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(AmazonTemplatesTemplate);
